import request from "../utils/request";

// 将对象的下划线 key 转为驼峰（递归处理对象和数组）
const camelizeKeys = (data) => {
  if (Array.isArray(data)) {
    return data.map(camelizeKeys);
  }
  if (data && typeof data === "object") {
    return Object.keys(data).reduce((acc, key) => {
      const camelKey = key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
      acc[camelKey] = camelizeKeys(data[key]);
      return acc;
    }, {});
  }
  return data;
};

// 智慧豆概览
export async function getBeanOverview(params) {
  const res = await request({
    url: "/open/bean_overview",
    method: "get",
    params,
  });

  // 接口返回下划线字段，统一转为驼峰
  if (res.code === 0) {
    res.data = camelizeKeys(res.data);
  }

  return res;
}

// 智慧豆明细分页
export async function getBeanDetailPage(params) {
  const res = await request({
    url: "/open/bean_detail_page",
    method: "get",
    params,
  });

  // 接口返回下划线字段，统一转为驼峰
  if (res.code === 0) {
    res.data = camelizeKeys(res.data);
  }

  return res;
}
